import React from "react";

const brandPrimary = "#2C2731";
const brandSurface = "#FFFCEF";
const brandSurfaceAlt = "#F2EAC3";
const brandMuted = "#403851";

export const tabBarStyle: React.CSSProperties = {
    display: "flex",
    gap: 8,
    flexWrap: "wrap",
    marginBottom: 16,
};

export const tabPanelStyle: React.CSSProperties = {
    border: `1px solid ${brandPrimary}`,
    borderRadius: 16,
    padding: 20,
    background: brandSurface,
    minHeight: 320,
    maxHeight: "70vh",
    overflowY: "auto",
    boxShadow: "inset 0 0 0 1px rgba(44,39,49,0.05)",
};

export const badgeRowStyle: React.CSSProperties = {
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
    marginBottom: 12,
};

export const badgeStyle: React.CSSProperties = {
    fontSize: 12,
    padding: "4px 10px",
    borderRadius: 999,
    border: `1px solid ${brandPrimary}`,
    background: brandPrimary,
    color: brandSurface,
};

export const avatarStyle: React.CSSProperties = {
    width: 48,
    height: 48,
    borderRadius: 999,
    background: brandPrimary,
    color: brandSurface,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 20,
    fontWeight: 600,
};

export const cardStyle: React.CSSProperties = {
    border: `1px solid ${brandPrimary}`,
    borderRadius: 16,
    padding: 16,
    marginBottom: 16,
    background: brandSurfaceAlt,
    boxShadow: "inset 0 0 0 1px rgba(44,39,49,0.05)",
};

export const sectionTitleStyle: React.CSSProperties = {
    fontWeight: 600,
    marginBottom: 8,
    color: brandPrimary,
};

export const mutedTextStyle: React.CSSProperties = {
    color: brandMuted,
    fontSize: 13,
};

export const chipWrapperStyle: React.CSSProperties = {
    display: "flex",
    flexWrap: "wrap",
    gap: 6,
};

export const chipStyle: React.CSSProperties = {
    display: "inline-block",
    background: brandSurface,
    border: `1px solid ${brandPrimary}`,
    borderRadius: 999,
    padding: "2px 10px",
    fontSize: 12,
    color: brandPrimary,
};

export const infoRowStyle: React.CSSProperties = {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 8,
    fontSize: 13,
    color: brandPrimary,
};

export const componentGridHeader: React.CSSProperties = {
    display: "grid",
    gridTemplateColumns: "1fr 60px 90px 90px",
    fontSize: 12,
    color: brandMuted,
    marginBottom: 6,
};

export const componentGridRow: React.CSSProperties = {
    display: "grid",
    gridTemplateColumns: "1fr 60px 90px 90px",
    fontSize: 13,
    color: brandPrimary,
    padding: "6px 0",
    borderTop: `1px solid ${brandPrimary}20`,
};

export const alignRight: React.CSSProperties = { textAlign: "right" };

export const emptyTextStyle: React.CSSProperties = {
    color: `${brandPrimary}80`,
    fontSize: 13,
    fontStyle: "italic",
};

export const backdrop: React.CSSProperties = {
    position: "fixed",
    inset: 0,
    background: "rgba(44,39,49,0.55)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 16,
    zIndex: 50,
};

export const modal: React.CSSProperties = {
    position: "relative",
    width: "min(960px, 100%)",
    background: brandSurface,
    borderRadius: 24,
    border: `1px solid ${brandPrimary}`,
    padding: 24,
    boxShadow: "0 24px 48px rgba(44,39,49,0.35)",
    color: brandPrimary,
    maxHeight: "90vh",
    overflowY: "auto",
};

export const iconBtn: React.CSSProperties = {
    border: `1px solid ${brandPrimary}`,
    borderRadius: 12,
    background: brandPrimary,
    color: brandSurface,
    padding: "6px 12px",
    cursor: "pointer",
    fontWeight: 600,
};
